module.exports = {"440281001":"乐城街道","440281102":"北乡镇","440281103":"九峰镇","440281104":"廊田镇","440281105":"长来镇","440281106":"梅花镇","440281107":"三溪镇","440281108":"坪石镇","440281110":"黄圃镇","440281111":"五山镇","440281112":"两江镇","440281113":"沙坪镇","440281114":"云岩镇","440281115":"秀水镇","440281117":"大源镇","440281118":"庆云镇","440281119":"白石镇","440281451":"坪梅矿务局坪石","440281452":"坪梅矿务局梅田"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440281.json
// module id = 2090
// module chunks = 0